export function copiarString(string) {

    // Cria um Blob a partir do conteúdo de texto
    const blob = new Blob([string], { type: 'text/plain' });

    // Cria um ClipboardItem com o Blob
    const clipboardItem = new ClipboardItem({ 'text/plain': blob });

    // Copia o ClipboardItem para a área de transferência
    navigator.clipboard.write([clipboardItem])
        .then(() => {
            console.log('Conteúdo copiado para a área de transferência como texto puro');
        })
        .catch(err => {
            console.error('Erro ao copiar para a área de transferência: ', err);
        });
}
